import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Activity, Users, Building2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminLayout() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-screen flex bg-background overflow-hidden">
      <aside className="w-[280px] h-screen border-r bg-muted/20 p-4 flex-shrink-0">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold">AI Analysis</h2>
        </div>

        <Button
          variant="outline"
          size="sm"
          className="w-full mb-4 justify-start"
          onClick={() => navigate("/dashboard")}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        <nav className="space-y-2">
          <NavItem to="/admin/overview" label="Overview" icon={<LayoutDashboard className="h-4 w-4" />} />
          {/* <NavItem to="/admin/uploads" label="Uploads" icon={<BarChart3 className="h-4 w-4" />} /> */}
          <NavItem to="/admin/findings" label="Findings" icon={<Activity className="h-4 w-4" />} />
          <NavItem to="/admin/radiologists" label="Radiologists" icon={<Users className="h-4 w-4" />} />
          <NavItem to="/admin/accounts" label="Accounts" icon={<Building2 className="h-4 w-4" />} />
        </nav>
      </aside>

      <main className="flex-1 h-screen overflow-y-auto min-w-0 p-6">
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({
  to,
  label,
  icon,
}: {
  to: string;
  label: string;
  icon: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors
        ${
          isActive
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:bg-muted hover:text-foreground"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}